import { ANIMATIONS } from "../constants/general";

export const sanitizedCommonObject = (object, canvas) => {
  const sanitizedObject = {};
  sanitizedObject.id = object.id;
  if (object.url) {
    sanitizedObject.url = object.url;
  }
  if (object.top !== null || object.top !== undefined) {
    sanitizedObject.top = object.top;
  }
  if (object.left !== null || object.left !== undefined) {
    sanitizedObject.left = object.left;
  }
  sanitizedObject.name = object.name;
  sanitizedObject.opacity = object.opacity || 1;
  sanitizedObject.width = object.width;
  sanitizedObject.animation = object.animation || ANIMATIONS.NONE;
  sanitizedObject.leftPercent = object.left / canvas.getWidth();
  sanitizedObject.topPercent = object.top / canvas.getHeight();
  sanitizedObject.widthPercent = object.width / canvas.getWidth();
  sanitizedObject.heightPercent = object.height / canvas.getHeight();
  sanitizedObject.height = object.height;
  sanitizedObject.scaleX = object.scaleX || 1;
  sanitizedObject.scaleY = object.scaleY || 1;
  sanitizedObject.scaleXPercent = object.scaleX / canvas.getWidth();
  sanitizedObject.scaleYPercent = object.scaleY / canvas.getHeight();
  sanitizedObject.type = object.type;
  sanitizedObject.angle = object.angle;
  sanitizedObject.stroke = object.stroke;
  sanitizedObject.fill = object.fill;
  sanitizedObject.opacity = object.opacity;

  return sanitizedObject;
};

export const sanitizedBackgroundColorObject = (object, canvas) => {
  object.type = "backgroundColor";
  object.color = object.color;

  return object;
};

export const sanitizedAvatarObject = (avatar, canvas) => {
  const sanitizeAvatar = sanitizedCommonObject(avatar, canvas);

  sanitizeAvatar.type = "avatar";
  sanitizeAvatar.top = avatar.top;
  sanitizeAvatar.left = avatar.left;
  sanitizeAvatar.angle = avatar.angle || 0;
  sanitizeAvatar.gender = avatar.gender || "Male";
  sanitizeAvatar.square = avatar.square || false;
  sanitizeAvatar.avatarCode = avatar.avatarCode;
  sanitizeAvatar.lockRotation = true;
  sanitizeAvatar.pro_avatar = avatar.pro_avatar;
  sanitizeAvatar.presenterId = avatar.presenterId;
  sanitizeAvatar.user_avatar = avatar.user_avatar;
  return sanitizeAvatar;
};

export const sanitizedBackgroundObject = (background, canvas) => {
  return sanitizedCommonObject(background, canvas);
};

export const sanitizedGraphicsObject = (graphics, canvas) => {
  const sanitizedGraphics = sanitizedCommonObject(graphics, canvas);

  sanitizedGraphics.type = "graphics";
  sanitizedGraphics.fill = graphics.fill;
  sanitizedGraphics.stroke = graphics.stroke;
  sanitizedGraphics.angle = graphics.angle || 0;
  sanitizedGraphics.strokeWidth = graphics.strokeWidth || 1;
  return sanitizedGraphics;
};

export const sanitizedTextObject = (text, canvas) => {
  const sanitizeText = sanitizedCommonObject(text, canvas);

  sanitizeText.type = "text";
  sanitizeText.text = text.text;
  sanitizeText.fontWeight = text.fontWeight;
  sanitizeText.fontSize = text.fontSize;
  sanitizeText.fontFamily = text.fontFamily;
  sanitizeText.fill = text.fill;
  sanitizeText.textAlign = text.textAlign;
  sanitizeText.underline = text.underline;
  sanitizeText.fontStyle = text.fontStyle;
  sanitizeText.opacity = text.opacity;
  sanitizeText.stroke = text.stroke;
  sanitizeText.strokeWidth = text.strokeWidth;

  return sanitizeText;
};

export const sanitizedImageObject = (image, canvas) => {
  const sanitizedImage = sanitizedCommonObject(image, canvas);
  sanitizedImage.type = "images";
  return sanitizedImage;
};
